<template>
  <div v-if="showControl == true" class="step-wrapper " :class="{ 'active': active }">
    <b-row >
      <b-col cols="6" sm="6" md="6" lg="4" xl="4">
        <b-button v-if="!firststep" variant="macal-light" size="lg" block :class="(firststep)? 'disabled' : ''" @click="lastStep()" :disabled="firststep">Anterior</b-button>
      </b-col>
      <b-col cols="6" sm="6" md="6" lg="4" xl="4" offset="4">
        <b-button variant="macal" size="lg" block v-if="!laststep" @click="nextStep()" :disabled="laststep">Siguiente</b-button>
        <b-button variant="macal" size="lg" block v-if="laststep" @click="saveStep()">Enviar</b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  export default {
    props: ['step', 'stepcount', 'currentstep', 'showControl'],

    computed: {
      active() {
        return (this.step.id === this.currentstep)
      },

      firststep() {
        return (this.currentstep === 1)
      },

      laststep() {
        return (this.currentstep === this.stepcount)
      }
    },

    methods: {
      nextStep() {
        this.$emit('step-change', this.currentstep + 1)
      },

      lastStep() {
        this.$emit('step-change', this.currentstep - 1)
      },

      saveStep() {
        this.$emit('step-save')
      }
    }
  }
</script>
